import { createTypes, createAction } from 'lib/action'

// *load ข้อมูลต้นแหล่ง
const MATERIAL_QUOTA_ASSIGN_LOCATION = createTypes(
  'materialQuotaAssignDashboardLoadLocation',
  'load'
)

// *load ข้อมูลวัตถุดิบ
const MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL = createTypes(
  'materialQuotaAssignLoadRawMaterial',
  'load'
)

// *load ข้อมูล table log
const MATERIAL_QUOTA_ASSIGN_TABLE_LOG = createTypes(
  'materialQuotaAssignLoadTableLog',
  'load'
)

// *export ข้อมูล
const EXPORT_MATERIAL_QUOTA_ASSIGN_TABLE_LOG = createTypes(
  'exportMaterialQuotaAssignLoadTableLog',
  'load'
)

// *load ข้อมูลวัตถุดิบ for edit
const MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL_EDIT = createTypes(
  'materialQuotaAssignLoadRawMaterialEdit',
  'load'
)

// *preview ข้อมูลโควตา
const MATERIAL_QUOTA_ASSIGN_PREVIEW = createTypes(
  'materialQuotaAssignPreview',
  'load'
)

// *update ข้อมูลโควตา
const MATERIAL_QUOTA_ASSIGN_UPDATE = createTypes(
  'materialQuotaAssignUpdate',
  'load'
)

// *remove lists
const REMOVE_LISTS = `REMOVE_LISTS`

// *remove lists
function removeLists() {
  return {
    type: REMOVE_LISTS,
  }
}
// *load ข้อมูลต้นแหล่ง
const materialQuotaAssignLoadLocation = {
  request: (data) =>
    createAction(MATERIAL_QUOTA_ASSIGN_LOCATION.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(MATERIAL_QUOTA_ASSIGN_LOCATION.SUCCESS, {
      lists,
    }),
  failure: () => createAction(MATERIAL_QUOTA_ASSIGN_LOCATION.FAITLURE),
}

// *load ข้อมูลวัตถุดิบ
const materialQuotaAssignLoadRawMaterial = {
  request: (data) =>
    createAction(MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL.SUCCESS, {
      lists,
    }),
  failure: () => createAction(MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL.FAITLURE),
}

// *load ข้อมูล table log
const materialQuotaAssignLoadTableLog = {
  request: (data) =>
    createAction(MATERIAL_QUOTA_ASSIGN_TABLE_LOG.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(MATERIAL_QUOTA_ASSIGN_TABLE_LOG.SUCCESS, {
      lists,
    }),
  failure: () => createAction(MATERIAL_QUOTA_ASSIGN_TABLE_LOG.FAITLURE),
}

// *export ข้อมูล
const exportMaterialQuotaAssignLoadTableLog = {
  request: (data) =>
    createAction(EXPORT_MATERIAL_QUOTA_ASSIGN_TABLE_LOG.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(EXPORT_MATERIAL_QUOTA_ASSIGN_TABLE_LOG.SUCCESS, {
      lists,
    }),
  failure: () => createAction(EXPORT_MATERIAL_QUOTA_ASSIGN_TABLE_LOG.FAITLURE),
}

// *load ข้อมูลวัตถุดิบ
const materialQuotaAssignLoadRawMaterialEdit = {
  request: (data) =>
    createAction(MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL_EDIT.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL_EDIT.SUCCESS, {
      lists,
    }),
  failure: () => createAction(MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL_EDIT.FAITLURE),
}

// *preview ข้อมูลโควตา
const materialQuotaAssignPreview = {
  request: (data) =>
    createAction(MATERIAL_QUOTA_ASSIGN_PREVIEW.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(MATERIAL_QUOTA_ASSIGN_PREVIEW.SUCCESS, {
      lists,
    }),
  failure: () => createAction(MATERIAL_QUOTA_ASSIGN_PREVIEW.FAITLURE),
}

// *update ข้อมูลโควตา
const materialQuotaAssignUpdate = {
  request: (data) =>
    createAction(MATERIAL_QUOTA_ASSIGN_UPDATE.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(MATERIAL_QUOTA_ASSIGN_UPDATE.SUCCESS, {
      lists,
    }),
  failure: () => createAction(MATERIAL_QUOTA_ASSIGN_UPDATE.FAITLURE),
}

export {
  REMOVE_LISTS,
  removeLists,
  MATERIAL_QUOTA_ASSIGN_LOCATION,
  materialQuotaAssignLoadLocation,
  MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL,
  materialQuotaAssignLoadRawMaterial,
  MATERIAL_QUOTA_ASSIGN_TABLE_LOG,
  materialQuotaAssignLoadTableLog,
  MATERIAL_QUOTA_ASSIGN_RAW_MATERIAL_EDIT,
  materialQuotaAssignLoadRawMaterialEdit,
  MATERIAL_QUOTA_ASSIGN_PREVIEW,
  materialQuotaAssignPreview,
  MATERIAL_QUOTA_ASSIGN_UPDATE,
  materialQuotaAssignUpdate,
  EXPORT_MATERIAL_QUOTA_ASSIGN_TABLE_LOG,
  exportMaterialQuotaAssignLoadTableLog
}
